/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для подарков в корзине
   */
  app.GiftsView = app.View.extend({
    el: '#gifts',
    views: [],
    run: function () {
      app.gifts = new app.Gifts();
      this.collection = app.gifts;
      this.collection.on('reset', this.render, this);
      this.listenTo(this.cart, 'sync', this.updateCollection);
    },

    /**
     * При синхронизации корзины обновляем коллекцию подарков.
     */
    updateCollection: function () {
      if (_.isObject(this.cart.gifts)) {
        this.collection.reset(_.toArray(this.cart.gifts));
      } else {
        this.collection.reset(this.cart.gifts);
      }
    },
    render: function () {
      var that = this;
      this.views = [];
      this.$el.html('');
      this.collection.each(function (model) {
        var giftView = new app.CartGiftView({
          model: model,
        });
        that.views.push(giftView);

        that.$el.append(giftView.render().el);
      });
    },
  });
})();

}.call(window));